import { Box, Typography } from "@mui/material";
import React from "react";
import Label from "../../../Common/Label/Label";
import UploadImageWrapper from "../../ImageUploadWrapper";
import { ErrorLabel } from "../../ElementForm";
import ImageUploader from "../../../Common/ImageUploader";
import { useCreateElementContext } from "../Context/CreateElementContext";
import useOptions from "../../hooks/useOptions";
import FormComponent from "../../../Common/FormComponent/FormComponent";

const containerProps = {
  sx: {
    display: "flex",
    gap: 2,
    "& > *": {
      flex: 1,
    },
  },
};
export const config = [
  {
    id: "priority",
    label: "Priority",
    type: "Dropdown",
    required: true,
    containerProps,
    props: {
      options: [],
      placeholder: "Select priority",
    },
  },
  {
    id: "buffer_hours",
    label: "Mandatory deadline buffer (Hr)",
    containerProps,
    required: false,
    props: {
      type: "number",
      inputProps: {
        min: 0,
      }
    },
  },
];

const SeriesDetails = ({}) => {
  const { form, handleImage } = useCreateElementContext();
  const { options } = useOptions();

  return (
    <Box py={2}>
      <Typography variant="h5">SERIES DETAILS</Typography>
      <Box maxWidth={"750px"} flex={1} display={"flex"} gap={2}>
        <Box display={"flex"} gap={2} mt={2} flexDirection={"column"} flex={1}>
          {config.map((item) => (
            <Box>
              <FormComponent
                config={item}
                form={form}
                key={item.id}
                otherOptions={options[item?.props?.optionsKey ?? item.id]}
              />
              <ErrorLabel label={form.errors[item.id]} />
            </Box>
          ))}
        </Box>
        <Box display={"flex"} flexDirection={"column"} gap={2}>
          <Box display={"flex"} gap={2}>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <Label>Portrait thumbnail</Label>
              <UploadImageWrapper
                UploadComponent={ImageUploader}
                onUpload={handleImage("portrait")}
                url={form.getValue("thumbnail.portrait")}
              />
              <ErrorLabel label={form.errors["thumbnail.portrait"]} />
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
              <Label>Landscape thumbnail</Label>
              <UploadImageWrapper
                UploadComponent={ImageUploader}
                onUpload={handleImage("landscape")}
                url={form.getValue("thumbnail.landscape")}
              />
              <ErrorLabel label={form.errors["thumbnail.landscape"]} />
            </Box>
          </Box>
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            The thumbnail aspect ratio is 0.8 for portrait and 1.66 for landscape.
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default SeriesDetails;
